import React from 'react'
import {Table,Button,Empty} from 'antd'
const DataView =(props)=> {
  console.log(props)
  return (
    <Table scroll={{ x: 'max-content' }}  className='product-content'  
    // rowSelection={[]} 
    columns={props?.columns} dataSource={props?.data} 
    pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: [10,20,50] }}
    onChange={()=>{
        
    }} locale={{
        emptyText: (
          <span>
            <Empty description={'Product Catalog is empty'} />
            {props?.children}
          </span>
        )
      }}/>
  )
}

export default DataView
